import React, {useEffect, useMemo, useState } from "react";
import PropTypes from "prop-types";
//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css";

//i18n
import { withTranslation } from "react-i18next";
import TableContainerCustom from "../../components/Common/TableContainerCustom";
import {Link} from "react-router-dom";
import {
    Container, UncontrolledTooltip,
    Button,
    Col,
    Row,
    Modal,
    ModalHeader,
    ModalBody,
    Form,
    Input,
    FormFeedback,
    Label,
    Card,
    CardBody,
} from "reactstrap";
import { useFormik } from "formik";
import * as Yup from "yup";

import {useSelector, useDispatch } from "react-redux";
import { getCatShippingCarrierList as onGetCatShippingCarrierList,
    saveCatShippingCarrier as onSaveCatShippingCarrier,
    updateCatShippingCarrier as onUpdateCatShippingCarrier,
    deleteCatShippingCarrier as onDeleteCatShippingCarrier
} from "store/catShippingCarrier/actions";


const CatShippingCarrierList = props => {

    const [modal, setModal] = useState(false);
    const [typeSubmit, setTypeSubmit] = useState({
        title : "Crear nueva Categoría de Arte",
        type : "new"
    });

    const [catShippingCarriersList, setCatShippingCarriersList] = useState([]);
    const [catShippingCarrier, setCatShippingCarrier] = useState(null);

    const { catShippingCarrierList } = useSelector(state => ({
        catShippingCarrierList: state.CatShippingCarrier.catShippingCarrierList,
      }));

    const { error } = useSelector(state => ({
        error: state.CatShippingCarrier.error,
    }));
    
    const dispatch = useDispatch();

    const validation = useFormik({
        // enableReinitialize : use this flag when initial values needs to be changed
        enableReinitialize: true,

        initialValues: {
            name: (catShippingCarrier && catShippingCarrier.name) || '',
            status: (catShippingCarrier && catShippingCarrier.status) || true,
        },
        validationSchema: Yup.object({
            name: Yup.string().required("Por favor ingresa el nombre del tipo de artesanía"),
        }),
        onSubmit: (values) => {
            if (typeSubmit.type==="edit" || typeSubmit.type==="delete") {
                const updateTypeCratf = {
                    id: catShippingCarrier.id,
                    orderId: values.orderId,
                    name: values.name,
                    active: values.active,

                };
                if (typeSubmit.type==="edit") {
                    dispatch(onUpdateCatShippingCarrier(updateTypeCratf));
                } else {
                    dispatch(onDeleteCatShippingCarrier(updateTypeCratf))
                }
                validation.resetForm();
                toggle();
            }
            else if(typeSubmit.type==="new")
            {
                const newCatTypeCraft = {
                    name: values["name"],
                };
                dispatch(onSaveCatShippingCarrier(newCatTypeCraft));
                //if(error.success!==undefined && error.success)
                //{
                    validation.resetForm();
                    toggle();
                //}

            }
        },
    });

    const handleCatShippingCarrierClick = (typeSub, arg)=> {
        const typeCraft = arg;
        setCatShippingCarrier({
            id: typeCraft.id,
            name: typeCraft.name,
            active: typeCraft.active,
        });
        setTypeSubmit({
            title: "Editar Tipo de Artesano",
            type: typeSub
        });
        toggle();
    };

    const handleShippingCarrierClick = () => {

        setTypeSubmit({
            title: "Crear nueva Paquetería",
            type:"new"
        });
        toggle();
    };

    const columns = useMemo(
        () => [
            {
                Header: 'ID',
                accessor: 'id',
            },
            {
                Header: 'Nombre',
                accessor: 'name',
            },

            {
                Header: 'Activo',
                accessor: 'active'
            },
            {
                Header: 'Opciones',
                accessor: 'options',
                Cell: (cellProps) => {
                    return (
                        <div className="d-flex gap-3">
                            <Link
                                to="#"
                                className="text-success"
                                onClick={() => {
                                    const catTypeCraft = cellProps.row.original;
                                    handleCatShippingCarrierClick("edit",catTypeCraft);
                                }}
                            >
                                <i className="mdi mdi-pencil font-size-18" id="edittooltip" />
                                <UncontrolledTooltip placement="top" target="edittooltip">
                                    Editar
                                </UncontrolledTooltip>
                            </Link>
                            <Link
                                to="#"
                                className="text-danger"
                                onClick={() => {
                                    const catTypeCraft = cellProps.row.original;
                                    handleCatShippingCarrierClick("delete", catTypeCraft);
                                }}
                            >
                                <i className="mdi mdi-delete font-size-18" id="deletetooltip" />
                                <UncontrolledTooltip placement="top" target="deletetooltip">
                                    Borrar
                                </UncontrolledTooltip>
                            </Link>
                        </div>
                    );
                }
            },
        ],
        []
    );

    //meta title
    document.title = "Categorías de Arte | Guelaguetza Designs";

    const toggle = () => {
        if (modal) {
            setModal(false);
            setCatShippingCarrier(null);
        } else {
            setModal(true);
        }
    };

    useEffect(() => {
        dispatch(onGetCatShippingCarrierList());
    }, [dispatch]);

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    {/* Render Breadcrumb */}
                    <Breadcrumbs
                        title={props.t("Categorias de Arte")}
                        breadcrumbItem={props.t("Lista")}
                    />
                    <Row>
                        <Col xs="12">
                            <Card>
                                <CardBody>
                    <TableContainerCustom
                        data={catShippingCarrierList}
                        isAddShippingCarrierList={true}
                        handleShippingCarrierClick={handleShippingCarrierClick}
                        isGlobalFilter={true}
                        isAddOptions={false}
                        customPageSize={10} columns={columns} />
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
            <Modal size={"lg"} isOpen={modal} toggle={toggle}>
                <ModalHeader toggle={toggle} tag="h4">
                    {typeSubmit.title}
                </ModalHeader>
                <ModalBody>
                    <Form
                        onSubmit={(e) => {
                            e.preventDefault();
                            validation.handleSubmit();
                            return false;
                        }}
                    >
                        <Card>
                            <CardBody>
                        <Row>
                            <Col className="col-12">
                                <div className="mb-3">
                                            <Label className="form-label">Nombre de la paquetería</Label>
                                            <Input
                                                name="name"
                                                type="text"
                                                placeholder="Ingresa el nombre de la categoría"
                                                onChange={validation.handleChange}
                                                onBlur={validation.handleBlur}
                                                value={validation.values.name || ""}
                                                invalid={
                                                    validation.touched.name && validation.errors.name ? true : false
                                                }
                                            />
                                            {validation.touched.name && validation.errors.name ? (
                                                <FormFeedback type="invalid">{validation.errors.name}</FormFeedback>
                                            ) : null}
                                        </div>
                            </Col>
                        </Row>
                            </CardBody>
                        </Card>
                        <Row>
                            {

                            }
                            <Col >
                                <div className="text-end">
                                    {
                                        typeSubmit.type==="delete" ?
                                            (
                                                <button
                                                    type="submit"
                                                    className="btn btn-danger save-user"
                                                >
                                                    Eliminar
                                                </button>
                                            ):
                                            (
                                                <button
                                                    type="submit"
                                                    className="btn btn-success save-user"
                                                >
                                                    Guardar
                                                </button>
                                            )
                                    }
                                </div>
                            </Col>
                        </Row>
                    </Form>
                </ModalBody>
            </Modal>
        </React.Fragment>
    );
};
CatShippingCarrierList.propTypes = {
    catCatShippingCarrierList: PropTypes.array,
    onGetCatCatShippingCarrierList: PropTypes.func,
    onSaveCatCatShippingCarrier:PropTypes.func
};



export default withTranslation()(CatShippingCarrierList);
